
import { connect } from "react-redux";
import {E2ETests} from "./e2e-tests";
import {loadOnboardingRuns} from "../../store/reducers/test-reducer";

const mapDispatchToProps = dispatch => {
  return {
    loadOnboardingRuns: () => dispatch(loadOnboardingRuns()),
  };
}

const mapStateToProps = state => {
  return {
    client: state.client,
    user: state.user,
    app: state.app,
    testRuns: state.testRuns,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(E2ETests);
